const READY_EVENTS = {
  API_READY: 'drift::apiReady',
  READY: 'drift::ready',
}

const CAPTURE_EVENTS = {
  EMAIL_CAPTURED: 'drift::emailCapture',
  PHONE_NUMBER_CAPTURED: 'drift::phoneCapture'
}

const CONVERSATION_EVENTS = {
  CONVERSATION_STARTED: 'drift::startConversation',
  CONVERSATION_SELECTED: 'drift::conversation:selected',
  CONVERSATION_BUTTON_CLICKED: 'drift::conversation:buttonClicked',
  CONVERSATION_INTERACTED: 'drift::conversation:firstInteraction',

  CONVERSATION_PLAYBOOK_CLICKED: 'drift::conversation:playbookClicked',
  CONVERSATION_PLAYBOOK_FIRED: 'drift::conversation:playbookFired',
  CONVERSATION_PLAYBOOK_DISMISSED: 'drift::conversation:playbookDismissed'
}

const MEETING_EVENTS = {
  MEETING_REQUESTED: 'drift::scheduling:requestMeeting',
  MEETING_BOOKED: 'drift::scheduling:meetingBooked'
}

const WELCOME_MESSAGE_EVENTS = {
  WELCOME_MESSAGE_OPENED: 'drift::welcomeMessage:open',
  WELCOME_MESSAGE_CLOSED: 'drift::welcomeMessage:close',

  AWAY_MESSAGE_OPENED: 'drift::awayMessage:open',
  AWAY_MESSAGE_CLOSED: 'drift::awayMessage:close',
}

const MESSAGE_EVENTS = {
  MESSAGE_RECEIVED: 'drift::message',
  MESSAGE_SENT: 'drift::message:sent'
}

const CAMPAIGN_EVENTS = {
  CAMPAIGN_CLICKED: 'drift::campaign:click',
  CAMPAIGN_SUBMITTED: 'drift::campaign:submit',
  CAMPAIGN_OPENED: 'drift::campaign:open',
  CAMPAIGN_DISMISSED: 'drift::campaign:dismiss'
}

const SLIDER_EVENTS = {
  SLIDER_CLOSED: 'drift::sliderMessage:close'
}

const CHAT_EVENTS = {
  CHAT_OPENED: 'drift::chatOpen',
  CHAT_CLOSED: 'drift::chatClose'
}

// These are deprecated events that are aliased to the chat events above
const SIDEBAR_EVENTS = {
  SIDEBAR_OPENED: 'drift::sidebarOpen',
  SIDEBAR_CLOSED: 'drift::sidebarClose'
}

const USER_EVENTS = {
  USER_ATTRIBUTES_UPDATED: 'drift::user:attributesUpdated'
}

const IFRAME_EVENTS = {
  IFRAME_RESIZED: 'drift::iframeResize'
}

const GDPR_EVENTS = {
  GDPR_CLICKED: 'drift::gdprClicked',
  GDPR_REQUESTED: 'drift::gdprRequested'
}

const BOOTSTRAP_EVENTS = {
  BOOTSTRAP_FAILED: 'drift::bootstrapFailed'
}

export const PUBLIC_EVENTS = {
  ...READY_EVENTS,
  ...CAPTURE_EVENTS,
  ...CONVERSATION_EVENTS,
  ...MEETING_EVENTS,
  ...WELCOME_MESSAGE_EVENTS,
  ...MESSAGE_EVENTS,
  ...CAMPAIGN_EVENTS,
  ...SLIDER_EVENTS,
  ...CHAT_EVENTS,
  ...SIDEBAR_EVENTS,
  ...USER_EVENTS,
  ...IFRAME_EVENTS,
  ...GDPR_EVENTS,
  ...BOOTSTRAP_EVENTS
}

export const PUBLIC_API_METHODS = [
  "init",
  "load",
  "track",
  "reset",
  "debug",
  "ping",
  "page",
  "on",
  "off",
  "show",
  "hide",
  "identify",
  "config",
  "unload",
  "setContext",

  // new methods
  "evaluateCampaignTargeting",
  "toggleHoursAndTargeting",

  "waitForUserJwt",
  "setUserJwt"
]

export const NESTED_API_METHODS = [
  "collectFormData",
  "commitFormData",
  "connectForm",
  "goToConversation",
  "goToNewConversation",
  "goToConversationList",
  "hideAwayMessage",
  "hideChat",
  "hideWelcomeMessage",
  "off",
  "on",
  "openChat",
  "toggleChat",
  "scheduleMeeting",
  "setUserAttributes",
  "showAwayMessage",
  "showWelcomeMessage",
  "showWelcomeOrAwayMessage",
  "stageFormData",
  "startInteraction",
  "startVideoGreeting",
  "toggleChat",
  "toggleChatTakeoverModal"
]

export const NESTED_API_WIDGET_METHODS = [
  "hide",
  "show"
]

export const HIDDEN_METHODS = [
  "toggleChatTakeoverModal"
]

export const READY_NOT_REQUIRED_METHODS = [
  "init",
  "load",
  "reset",
  "debug",
  "on",
  "off",
  "unload",
  "identify",
  "show",
  "hide",
  "config",
  "setContext"
]

export const ALL_METHODS = PUBLIC_API_METHODS.concat(NESTED_API_METHODS)

export const PRIVATE_EVENTS = {
  ALL_FRAMES_READY: 'drift::allFramesReady',
  CLEAR_EVENT_Q: 'drift::_clearEventQ',
  CHAT_READY: 'drift::chatReady',
  CONTROLLER_READY: 'drift::controllerReady',
  LANDINGPAGE_READY: 'drift::landingPageReady'
}

export const INIT_CRITICAL_EVENTS  = [
  PUBLIC_EVENTS.READY,
  PUBLIC_EVENTS.API_READY,
  PRIVATE_EVENTS.CONTROLLER_READY,
  PRIVATE_EVENTS.LANDINGPAGE_READY,
  PRIVATE_EVENTS.CHAT_READY,
  PRIVATE_EVENTS.CLEAR_EVENT_Q,
  PRIVATE_EVENTS.ALL_FRAMES_READY
]
